import React, {useEffect, useState} from 'react';
import MobileLogoBlock from './MobileLogoBlock';
import images from '../images';
import useAuth from '../hooks/useAuth';
import {useNotifications} from "../context/NotificationsContext";
import {getAuthenticatedUser} from "../api/auth.sso";

const MobileHeaderTop = () => {
  const { user } = useAuth();
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { openNotifications } = useNotifications();

  const handleOpenNotificationsModal = () => {
    openNotifications(userData.id);
  };

  const handleTelegramClick = () => {
    console.log('handleTelegramClick', userData.tg_utl);
    if (userData?.tg_utl) {
      window.open(userData.tg_utl, '_blank', 'noopener,noreferrer');
    }
  };

  const handleRulesClick = () => {
    window.open('https://docs.google.com/document/d/1tarscKtoRJdB8ZndtuVDLQdgfOq8Qz4hEboO46dv_ng/edit?tab=t.0', '_blank', 'noopener,noreferrer');
  };

  useEffect(() => {
    let isMounted = true;

    const loadUserData = async () => {
      try {
        setLoading(true);
        setError(null);

        // 1. Получаем данные пользователя
        const userData = await getAuthenticatedUser();
        console.log("userData: ", userData);
        // Проверяем, что компонент все еще смонтирован перед обновлением состояния
        if (!isMounted) return;

        setUserData(userData);

      } catch (error) {
        // Проверяем, что компонент все еще смонтирован перед обновлением состояния
        if (isMounted) {
          console.error('Ошибка при загрузке данных профиля:', error);
          setError(error.message || 'Не удалось загрузить данные профиля');
        }
      } finally {
        // Проверяем, что компонент все еще смонтирован перед обновлением состояния
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    loadUserData();

    // Очистка при размонтировании компонента
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <div className="mobile-header-top">
      <MobileLogoBlock />

      <div className="header-top-actions">
        {user?.tg_utl && (
            <button
                className="header-action-btn"
                onClick={handleTelegramClick}
            >
              <img src={images.telegram} alt="Telegram" className="header-action-icon"/>
            </button>
        )}
        <button className="header-action-btn" onClick={() => handleOpenNotificationsModal()}>
          <img src={images.bellBold} alt="" className="header-action-icon"/>
        </button>
        <button
            className="header-action-btn"
            onClick={handleRulesClick}
        >
          <img src={images.question} alt="Правила" className="header-action-icon"/>
        </button>
      </div>
    </div>
  );
};

export default MobileHeaderTop;
